import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import flowRight from 'lodash/flowRight'
//@ts-ignore
import { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import { reactForm } from 'shared/reactForm'
import { changePasswordForced } from '../../store/auth'
import { translate, translateLKM, translateWeb, preventDefaultListeners } from './helpers'
import { validatePassword } from './changePassword.utils'
import { ChangePasswordBase } from './ChangePasswordBase'
import { ChangePasswordField as Field } from './ChangePasswordField'
import { AUTH_CHANGE_PASSWORD_MODAL } from './constants'
import {
  ChangePasswordFormModalProps,
  AuthChangePasswordModalProps,
  ChangePasswordModalFormValues,
} from './ChangePasswordForm.types'
import { AppDispatch } from 'src/store/index.d'

const enhance = flowRight(
  reactForm({
    initialValues: () => ({
      oldPassword: '',
      newPassword: '',
      repeatPassword: '',
      otp: '',
    }),
    validate: (values: ChangePasswordModalFormValues, ownProps: ChangePasswordFormModalProps) => {
      const passwordValidation = validatePassword(values.newPassword, ownProps.rules)

      return {
        oldPassword: !values.oldPassword ? 'oldPassword is required' : undefined,
        newPassword: !Object.keys(passwordValidation)
          .filter((key) => typeof passwordValidation[key] === 'boolean')
          .every((key) => passwordValidation[key])
          ? translateWeb('INVALID_PASSWORD')
          : undefined,
        repeatPassword: values.repeatPassword !== values.newPassword ? translateLKM('MSG_PASSWD_NEW_BAD') : undefined,
        otp: !values.otp ? 'otp is required' : undefined,
      }
    },
  }),
)

const ChangePasswordForm = enhance((props: ChangePasswordFormModalProps) => {
  const { username, closeModal, form } = props

  const dispatch = useDispatch<AppDispatch>()

  const [oldPasswordError, setOldPasswordError] = React.useState('')

  const handleSubmit = React.useCallback(() => {
    form.handleSubmit((values) => {
      setOldPasswordError('')

      async function submitChangePasswordForm() {
        //@ts-ignore
        const result: {
          type: string
          payload?: string
          meta: any
        } = await dispatch(
          changePasswordForced({
            username,
            password: values.oldPassword,
            newPassword: values.newPassword,
            otp: values.otp,
          }),
        )

        if (changePasswordForced.rejected.match(result)) {
          const message = translateLKM(result.payload)

          dispatch(LKModalActions.openError(message))
          setOldPasswordError(message)
          return
        }

        closeModal()
        dispatch(LKModalActions.openInfo('პაროლი შეიცვალა'))
      }

      submitChangePasswordForm()
    })
  }, [dispatch, closeModal, form, username])

  return (
    //@ts-ignore
    <ChangePasswordBase
      {...props}
      onSubmit={handleSubmit}
      oldPasswordError={oldPasswordError}
      fields={
        <>
          <Field
            label={translate('lbl_pass')}
            form={form}
            type="password"
            name="oldPassword"
            {...preventDefaultListeners}
          />
          <Field
            label={translate('lbl_new_pass')}
            form={form}
            type="password"
            name="newPassword"
            {...preventDefaultListeners}
          />
          <Field
            label={translate('lbl_new_pass_confirm')}
            form={form}
            type="password"
            name="repeatPassword"
            {...preventDefaultListeners}
          />
          <Field label={'კოდი'} form={form} type="text" name="otp" />
        </>
      }
    />
  )
})

const AuthChangePasswordModal: FC<AuthChangePasswordModalProps> = ({ modalInstanceName, params, closeModal }) => (
  <ChangePasswordForm
    modalName={modalInstanceName}
    closeModal={closeModal}
    lock={() => {}}
    lockOnClose={params.lockOnClose}
    allowSkip={false}
    username={params.username}
    rules={params.passwordRules}
    passwordExpired
  />
)

export default LKModalContainer(AUTH_CHANGE_PASSWORD_MODAL)(AuthChangePasswordModal)
